import api from "PFCore/api";
import { Id } from "PFCore/types";
import { KPIResult } from "PFCore/types/kpi";

export const fetchKPIResult = (engagementId: Id, indicatorId: Id) =>
  api<KPIResult>({
    url: `kpi_results/${indicatorId}`,
    params: {
      engagementId
    }
  });
